import {PAUSE, READY, REGISTER, TAKING} from 'shared/constant/lookup/eventState'
import Style from './style'

const Badge = ({event_state, isUsed, isTourInfo}) => {
	if (isTourInfo) {
		return (
			<Style.BadgesContainer>
				<Style.StatusBadge
					statusColor={
						event_state === REGISTER || event_state === READY
							? 'upcoming'
							: event_state === TAKING
							? 'inProgress'
							: event_state === PAUSE
							? 'pause'
							: 'end'
					}
				>
					<Style.StatusText>
						{event_state === REGISTER || event_state === READY
							? 'Upcoming'
							: event_state === TAKING
							? 'In Progress'
							: event_state === PAUSE
							? 'Pause'
							: 'End'}
					</Style.StatusText>
				</Style.StatusBadge>
			</Style.BadgesContainer>
		)
	}

	return (
		<Style.BadgesContainer>
			<Style.StatusBadge statusColor={isUsed ? 'isUsed' : 'participating'}>
				<Style.StatusText>{isUsed ? 'Used' : 'Not in used'}</Style.StatusText>
			</Style.StatusBadge>
		</Style.BadgesContainer>
	)
}

export default Badge
